import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { ItemMaster } from '../../models/item/item-master';
import { Observable } from 'rxjs';
import { MatchingItemMasterCommand } from '../../models/item/yarn/yarn-search';

@Injectable({
  providedIn: 'root',
})
export class YarnProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/yarn';

  getItemMastersByYarnCode(command: MatchingItemMasterCommand[]): Observable<ApiResponse<Record<string, ItemMaster | null>>> {
    return this.httpClient.post<ApiResponse<Record<string, ItemMaster | null>>>(`${this.baseUrl}/yarn-code/batch/item-master`, command);
  }
}
